var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgBold = function SvgBold(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 4.03846C5 3.74108 5.24108 3.5 5.53846 3.5H9.5C10.8807 3.5 12 4.61929 12 6V6C12 7.38071 10.8807 8.5 9.5 8.5H5V4.03846Z",
    stroke: "#888EA7",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5 8.5H10.5C12.433 8.5 14 10.067 14 12V12C14 13.933 12.433 15.5 10.5 15.5H5.69231C5.30996 15.5 5 15.19 5 14.8077V8.5Z",
    stroke: "#888EA7",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgBold);
export { ForwardRef as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTgiIGhlaWdodD0iMTkiIHZpZXdCb3g9IjAgMCAxOCAxOSIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTUgNC4wMzg0NkM1IDMuNzQxMDggNS4yNDEwOCAzLjUgNS41Mzg0NiAzLjVIOS41QzEwLjg4MDcgMy41IDEyIDQuNjE5MjkgMTIgNlY2QzEyIDcuMzgwNzEgMTAuODgwNyA4LjUgOS41IDguNUg1VjQuMDM4NDZaIiBzdHJva2U9IiM4ODhFQTciIHN0cm9rZS13aWR0aD0iMiIvPgo8cGF0aCBkPSJNNSA4LjVIMTAuNUMxMi40MzMgOC41IDE0IDEwLjA2NyAxNCAxMlYxMkMxNCAxMy45MzMgMTIuNDMzIDE1LjUgMTAuNSAxNS41SDUuNjkyMzFDNS4zMDk5NiAxNS41IDUgMTUuMTkgNSAxNC44MDc3VjguNVoiIHN0cm9rZT0iIzg4OEVBNyIgc3Ryb2tlLXdpZHRoPSIyIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+Cjwvc3ZnPgo=";